<template>
  <div class="connections">
    <a-button-box :active="state.matches('participantsNetwork.visible')">
      <a-button ref="toggle" variant="link-primary" @click="toggleHandler">
        <a-icon
          v-if="!user.isInLobby"
          :name="user.networkIcon(user.qualityNetwork).name"
          :color="user.networkIcon(user.qualityNetwork).color"
          :width="24"
          :height="24"
        />
        <a-icon
          v-else
          :name="`wifi-on`"
          :color="`grey`"
          :width="24"
          :height="24"
        />
      </a-button>
    </a-button-box>
    <Transition name="fade">
      <div
        class="box mb--0 mt--1"
        ref="targetNetwork"
        v-show="state.matches('participantsNetwork.visible')">
        <div class="box__header">
          <h2>{{ $t('participants.title') }}</h2>
        </div>
        <div class="box__content">
          <a-connection-status></a-connection-status>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import {ref} from 'vue'
import { useUserStore} from '@/stores'
import {useMeetingMachine} from '@/state'
import {onClickOutside} from '@vueuse/core'
import AIcon from '@/components/AIcon.vue'
import AConnectionStatus from '@/components/AConnectionStatus.vue'
const user = useUserStore()
const {state, send} = useMeetingMachine()
const toggle = ref(null)
const targetNetwork = ref(null)

function toggleHandler() {
    if (state.value.matches('participantsNetwork.visible')) {
      send('HIDE_PARTICIPANTS_NETWORK')
    } else {
      send('SHOW_PARTICIPANTS_NETWORK')
    }
}

onClickOutside(targetNetwork, event => {
  if (state.value.matches('participantsNetwork.visible') && event.target !== toggle.value.$el) {
    send('HIDE_PARTICIPANTS_NETWORK')
  }
})
</script>

<style lang="scss">
$participants-max-width: calc(100vw - #{$box-spacer * 2});
$participants-width-breakpoint-sm: calc(100vw - #{$box-spacer * 3.6});
.connections {
  position: relative;

  .box {
    position: absolute;
    top: 100%;
    right: 0;
    max-width: $participants-max-width;
    max-height: calc(
      100dvh - #{$component-height + $box-spacer + map-get($spacers, 2)} - 3.625rem
    ); // TODO: tools height variable
    overflow: auto;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: sticky;
      top: 0;
      left: 0;
      width: 100%;
      padding-bottom: $box-spacer;
      z-index: 1;

      .btn {
        position: relative;
        top: 0;
        right: 0;
      }
    }
  }

  @media (max-width: $breakpoint-sm) {
    .box {
      width: $participants-width-breakpoint-sm;
    }
  }
}
</style>
